// This file is automatically generated. Do not edit manually.

import { CustomerOrderPartCostView } from "src/api/generated/erp/db/types/tables/customerOrderPartCostView";
import { PartView } from "src/api/generated/erp/db/types/tables/partView";
import { PartCostOverrideOptionsProvider_PropertyValueOption } from "src/api/generated/erp/sales/partCostOverride/partCostOverrideOptionsProvider";
import { PartCostOverrideConditions } from "src/api/generated/io/aavo/applications/db/erp/types/partCostOverrideConditions";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderPartCostOverrideApi {
	export async function getPartCostOverrides(args: {
		customerOrderId: number;
	}): Promise<Array<CustomerOrderPartCostView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/partCostOverrides/getPartCostOverrides",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
			},
		});
		return response as Array<CustomerOrderPartCostView>;
	}

	export async function getPartOptions(args: { customerOrderId: number }): Promise<Array<PartView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/partCostOverrides/getPartOptions",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
			},
		});
		return response as Array<PartView>;
	}

	export async function getPropertyValueOptions(args: {
		customerOrderId: number;
		partId: number;
	}): Promise<Array<PartCostOverrideOptionsProvider_PropertyValueOption>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/partCostOverrides/getPropertyValueOptions",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				partId: args.partId,
			},
		});
		return response as Array<PartCostOverrideOptionsProvider_PropertyValueOption>;
	}

	export async function createPartCostOverride(args: {
		customerOrderId: number;
		partId: number;
		propertyConditions: PartCostOverrideConditions;
		unitCost: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/partCostOverrides/createPartCostOverride",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				partId: args.partId,
				propertyConditions: args.propertyConditions,
				unitCost: args.unitCost,
			},
		});
		return response as void;
	}

	export async function updatePartCostOverride(args: {
		customerOrderId: number;
		customerOrderPartCostId: number;
		partId: number;
		propertyConditions: PartCostOverrideConditions;
		unitCost: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/partCostOverrides/updatePartCostOverride",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				customerOrderPartCostId: args.customerOrderPartCostId,
				partId: args.partId,
				propertyConditions: args.propertyConditions,
				unitCost: args.unitCost,
			},
		});
		return response as void;
	}

	export async function deletePartCostOverride(args: {
		customerOrderId: number;
		customerOrderPartCostId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/partCostOverrides/deletePartCostOverride",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				customerOrderPartCostId: args.customerOrderPartCostId,
			},
		});
		return response as void;
	}
}
